module.exports = {
        srcSet: __webpack_public_path__ + "static/media/phone-498.8eeef280.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/phone-498.8eeef280.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/phone-498.8eeef280.webp",
        toString: function(){return __webpack_public_path__ + "static/media/phone-498.8eeef280.webp"},
        
        width: 498,
        height: 498
      }